module.exports = __webpack_public_path__ + "static/media/fave-feed-modal-3.df3575c8.svg";